"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use CartEmpty from foundation/CartEmpty
 * @trackcomponent
 */
export const Cart = createSVGIcon(
  <>
    <rect x="0.5" y="4.75" width="16" height="11.75" stroke="currentColor" />
    <path d="M3.8252 7.22498V0.849976H13.1752V7.22498" stroke="currentColor" />
  </>,
  "Cart",
  { viewBox: "0 0 17 17", titleAccess: "Cart", fill: "none" }
);
